import BaseObject, { BaseObjectParams } from '../baseObject';
import Element from '../element/element';
import Game from '../game';

export interface SpriteParams extends BaseObjectParams {
  element?: Element;
  src?: string;
  image?: HTMLImageElement | HTMLCanvasElement;
  width?: number;
  height?: number;
  offsetCenterX?: number;
  offsetCenterY?: number;
  ignoreScale?: boolean;
}

export default class Sprite extends BaseObject implements SpriteParams {
  element!: Element;
  src!: string;
  image!: HTMLImageElement | HTMLCanvasElement;
  width!: number;
  height!: number;
  offsetCenterX = 0;
  offsetCenterY = 0;
  ignoreScale = false; // will be always drawn at the same relative size if true

  widthDefault!: number;
  heightDefault!: number;

  constructor(params: SpriteParams) {
    super();
    this.applyParams(params);

    if (this.src) {
      this.image = new Image();
      this.image.setAttribute('src', this.src);
    }
  }

  get canvas(): HTMLCanvasElement {
    return this.element?.context?.canvas;
  }

  get context(): CanvasRenderingContext2D {
    return this.element?.context;
  }

  draw(): CanvasRenderingContext2D {
    if (this.width === undefined) {
      this.width = this.element.width;
      this.widthDefault = this.width;
    }
    if (this.height === undefined) {
      this.height = this.element.height;
      this.heightDefault = this.height;
    }

    const zoomRatio = Game.instance?.scene?.camera.zoomRatio;
    let { width, height } = this;
    if (this.ignoreScale) {
      width = this.widthDefault / zoomRatio;
      height = this.heightDefault / zoomRatio;
    }
    const context = this.context;
    const {
      image,
      offsetCenterX,
      offsetCenterY,
    } = this;
    context.drawImage(
      image,
      -width / 2 + offsetCenterX / zoomRatio,
      -height / 2 + offsetCenterY / zoomRatio,
      width,
      height,

    );
    return context;
  }
}
